import { darken, readableColor, transparentize } from 'polished';
import styled, { InputColorScheme } from 'styled-components';

export const WrapperInput = styled.div`
  position: relative;
  width: 100%;
  height: 36px;
`;

export const WrapperIcon = styled.span`
  position: absolute;
  cursor: pointer;
  font-size: ${(p) => p.theme.font.xLarge};
  line-height: 1em;
  display: flex;

  top: 50%;
  transform: translateY(-50%);

  right: 12px;

  & svg {
    stroke-width: 2;
  }
`;

type TStyledInput = {
  color: InputColorScheme;
  hasIcon?: boolean;
};

export const StyledInput = styled.input<TStyledInput>`
  cursor: pointer;
  height: 100%;
  width: 100%;
  padding: ${(p) => p.theme.spacing.small} 14px;
  padding-right: ${(p) => `calc(12px + 12px + ${p.theme.font.xLarge})`};
  border-radius: ${(p) => p.theme.borderRadius};
  font-size: ${(p) => p.theme.font.small};
  line-height: ${(p) => p.theme.spacing.medium};
  border: 1px solid ${(p) => p.theme.colors.border};
  background-color: ${(p) => p.theme.input[p.color]};
  color: ${(p) =>
    readableColor(
      darken(0.2, p.theme.input[p.color]),
      p.theme.colors.textDark,
      p.theme.colors.textLight
    )};

  transition: background-color 0.3s, border 0.3s;
  will-change: background-color, border;

  &:disabled {
    background-color: ${(p) => p.theme.input.disabled};
  }
`;

export const Dropdown = styled.div<{ selectClientRect: DOMRect | undefined }>`
  position: absolute;
  background-color: ${(p) => p.theme.colors.background};
  top: ${({ selectClientRect }) => (selectClientRect?.bottom || 0) - 1}px;
  width: ${({ selectClientRect }) => selectClientRect?.width}px;
  left: ${({ selectClientRect }) => selectClientRect?.left}px;
  border: 1px solid ${(p) => p.theme.colors.border};
  border-top: none;
  overflow-x: auto;
  border-bottom-left-radius: ${(p) => p.theme.borderRadius};
  border-bottom-right-radius: ${(p) => p.theme.borderRadius};

  transition: visibility 0.3s, opacity 0.3s, transform 0.3s;

  transform: translateY(-5px);
  opacity: 0;
  visibility: hidden;

  &.isOpen {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  max-height: 200px;
`;

export const Option = styled.div`
  cursor: pointer;
  font-size: ${(p) => p.theme.font.small};
  padding: ${(p) => p.theme.spacing.small} 14px;

  background-color: ${(p) => p.theme.colors.background};

  transition: background-color 0.3s;

  border-top: 1px solid ${(p) => p.theme.colors.border};

  &:hover {
    background-color: ${(p) => p.theme.colors.backgroundHover};
  }

  &.isActive {
    color: ${(p) =>
      readableColor(
        p.theme.colors.primary,
        darken(0.5, p.theme.colors.primary),
        p.theme.colors.primary,
        false
      )};
    background-color: ${(p) => transparentize(0.95, p.theme.colors.primary)};
  }
`;
